import { render, staticRenderFns } from "./BuscarPacienteTurno.vue?vue&type=template&id=2ac3f35f&scoped=true"
import script from "./BuscarPacienteTurno.vue?vue&type=script&lang=js"
export * from "./BuscarPacienteTurno.vue?vue&type=script&lang=js"
import style0 from "./BuscarPacienteTurno.vue?vue&type=style&index=0&id=2ac3f35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3f35f",
  null
  
)

export default component.exports